import { memo } from 'react';
import { useIntl } from 'react-intl';
import { GestureResponderEvent } from 'react-native';

import { ActionSheet, ActionSheetRow, IconAdd, IconStore, ScrollView } from '@fhs/ui';
import { InlineAlert } from '@fhs-legacy/universal-components';

type StoreOption = {
  storeName: string;
  storeAddress: string;
  onPress: (event: GestureResponderEvent) => void;
};

type OtherOption = {
  label: string;
  onPress: (event: GestureResponderEvent) => void;
};

type ConfirmStoreActionSheetProps = {
  isDelivery: boolean;
  option1: StoreOption;
  option2: StoreOption;
  option3: OtherOption;
  isVisible: boolean;
  onClose: () => void;
};

function _ConfirmStoreActionSheet({
  isDelivery = false,
  isVisible = false,
  option1,
  option2,
  option3,
  onClose,
}: ConfirmStoreActionSheetProps) {
  const { formatMessage } = useIntl();

  const title = isDelivery
    ? formatMessage({ id: 'selectYourDeliveryAddress' })
    : formatMessage({ id: 'selectYourPickUpStore' });

  return (
    <ActionSheet isVisible={isVisible} headerTitle={title} onClose={onClose}>
      <InlineAlert
        message={'Changing your current store will empty your cart'}
        status="warning"
        iconCentered={true}
        style={{ alignItems: 'center' }}
      />
      <ScrollView>
        <ActionSheetRow type="radio" icon={<IconStore size={24} />} onPress={option1.onPress}>
          <ActionSheetRow.Item firstLine={option1.storeName} secondLine={option1.storeAddress} />
        </ActionSheetRow>
        <ActionSheetRow type="radio" icon={<IconStore size={24} />} onPress={option2.onPress}>
          <ActionSheetRow.Item firstLine={option2.storeName} secondLine={option2.storeAddress} />
        </ActionSheetRow>
        <ActionSheetRow type="radio" icon={<IconAdd size={24} />} onPress={option3.onPress}>
          <ActionSheetRow.Item firstLine={option3.label} />
        </ActionSheetRow>
      </ScrollView>
    </ActionSheet>
  );
}

export const ConfirmStoreActionSheet = memo(_ConfirmStoreActionSheet);
